import { ReactNode } from "react";
import tw from "src/utils/tw";

interface Props {
  className?: string;
  children: ReactNode;
}

export function GrayIcon(props: Props) {
  return (
    <div
      className={tw(
        "h-5 w-5 rounded bg-borderGray pt-0.5 text-center text-xs text-darkGray",
        props.className
      )}
    >
      {props.children}
    </div>
  );
}
